import { render, staticRenderFns } from "./DangerWarnWorkOccur.vue?vue&type=template&id=87f8e268&"
import script from "./DangerWarnWorkOccur.vue?vue&type=script&lang=js&"
export * from "./DangerWarnWorkOccur.vue?vue&type=script&lang=js&"
import style0 from "./DangerWarnWorkOccur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87f8e268')) {
      api.createRecord('87f8e268', component.options)
    } else {
      api.reload('87f8e268', component.options)
    }
    module.hot.accept("./DangerWarnWorkOccur.vue?vue&type=template&id=87f8e268&", function () {
      api.rerender('87f8e268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/DangerWarnWorkOccur.vue"
export default component.exports